// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"455e986a","651":"a632e044","858":"2a4a6968"}[chunkId] + ".chunk.js";
};